import { useContext } from 'react';

import { PremiumGuardContext } from './PremiumGuardContext';
import { PremiumGuardType } from './usePremiumGuardBuilder';

function usePremiumGuard(): PremiumGuardType {
  return useContext(PremiumGuardContext);
}

export default usePremiumGuard;
